/**
 * Testi italiani condivisi da più aree: comandi, colonne, stati di lettura.
 *
 * Qui sta ciò che comparirebbe identico in tre pagine diverse — «Annulla»,
 * «Riprova», «Creato il» — e che deve restare identico davvero: una colonna
 * chiamata «Creato il» in una pagina e «Data di creazione» in un'altra è la
 * stessa incoerenza che il glossario della skill `testi-ui-italiano` esiste per
 * impedire.
 */

/** Testi comuni a tutta la dashboard. */
export const common = {
  /** Comandi che compaiono in più pagine. */
  actions: {
    /** Pulsante che chiude un form o una conferma senza agire. */
    cancel: 'Annulla',
    /** Pulsante che riesegue una lettura fallita. */
    retry: 'Riprova',
    /** Pulsante che apre la pagina di una riga di tabella. */
    open: 'Apri',
    /** Nome accessibile del pulsante «Apri» di una riga, che nomina la riga. */
    openNamed: 'Apri {{name}}',
    /** Collegamento di rientro all'elenco dei progetti. */
    backToProjects: 'Torna ai progetti',
    /** Collegamento di rientro alla pagina iniziale del ruolo. */
    backToHome: 'Torna alla pagina iniziale',
  },

  /** Intestazioni di colonna usate da più tabelle. */
  columns: {
    /** Nome leggibile della risorsa. */
    name: 'Nome',
    /** Identificativo breve che compare negli URL. */
    slug: 'Slug',
    /** Stato del ciclo di vita della risorsa. */
    status: 'Stato',
    /** Nome utente di chi ha creato la risorsa. */
    createdBy: 'Creato da',
    /** Data di creazione. */
    createdAt: 'Creato il',
    /** Descrizione libera. */
    description: 'Descrizione',
    /** Colonna dei pulsanti di riga. */
    actions: 'Comandi',
  },

  /** Stati di una sezione che legge dati. */
  state: {
    /** Descrizione di uno stato vuoto senza un testo più preciso. */
    noData: 'Nessun dato',
    /** Titolo mostrato quando il backend nega la lettura. */
    forbiddenTitle: 'Permesso mancante',
    /** Spiegazione predefinita del permesso mancante. */
    forbiddenText: 'Per vedere questi dati devi amministrare il progetto.',
    /** Attesa della prima risposta del gateway sullo stato della sessione. */
    checkingSession: 'Verifica della sessione…',
  },

  /** Messaggi d'errore che non appartengono a una sola pagina. */
  errors: {
    /** Ricaduta quando l'errore non viene dal backend: rete, difetto, timeout. */
    generic: 'Richiesta non riuscita. Riprova.',
    /** Sessione decaduta durante la navigazione. */
    sessionExpired: 'Sessione scaduta. Accedi di nuovo.',
  },

  /** Ruoli globali mostrati accanto a un utente. */
  roles: {
    /** Testo al posto delle etichette quando l'utente non ha ruoli. */
    none: 'Nessun ruolo',
  },
};

/** Forma dei testi comuni, usata per tipare le altre lingue. */
export type Common = typeof common;
